"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "meterConsumptions",
    path: "/meter-consumptions",
    component: "MeterConsumptionBrowser"
});
let MeterConsumptionBrowser = class MeterConsumptionBrowser extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "MeterConsumptionBrowser.dsParams");
    }
    onCreateInvoicesPayload(...args) {
        return { consumptions: _.map(this.selectedItems, 'id') };
    }
    onGenerateMeterConsumptions(...args) {
        return this.$imodal
            .show({ name: 'GenerateMeterConsumptions' })
            .then(result => {
            console.log(result);
            if (!result || result.cancel || !result.value) {
                return;
            }
            this.$emit('slickgrid:reload', { grid: this.gridName });
            return result.value;
        });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    gridName;
    selectedItems;
    dsParams;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('integro_api/browse_meter_consumption', {
            parameters: () => ({
                ...this.dsParams,
                unbilled_only: this.dsParams.unbilled_only ? 1 : null
            })
        });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['gridName', 'selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                gridName: "meterConsumptions",
                selectedItems: [],
                dsParams: {
                    unbilled_only: true,
                },
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_2248226175642056_columns: [{
                        field: "invoice",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Invoice"),
                        params: {
                            sortPath: "invoice.invoice_number",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                            ],
                        },
                    },
                    {
                        field: "meter",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Meter"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.serial_number }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "meter",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "meter.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "meter_type",
                        name: this.$fn.pgettext("MeterBrowser", "Meter type"),
                        params: {
                            sortPath: "meter.meter_type",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "meter.meter_type",
                                },
                            },
                            {
                                name: "gettext",
                                context: "MeterTypes",
                                conversion: "Sentence",
                                filterInput: true,
                            },
                        ],
                    },
                    {
                        field: "meter_description",
                        name: this.$fn.pgettext("MeterBrowser", "Description"),
                        params: {
                            sortPath: "meter.description",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "meter.description",
                                },
                            },
                        ],
                    },
                    {
                        field: "meter_tag_id",
                        name: this.$fn.pgettext("MeterBrowser", "Tag ID"),
                        params: {
                            sortPath: "meter.tag_id",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "meter.tag_id",
                                },
                            },
                        ],
                    },
                    {
                        field: "start.date",
                        type: "date",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Start date"),
                        params: {
                            sortPath: "start.date",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "start.date",
                                },
                            },
                        ],
                    },
                    {
                        field: "start.reading",
                        type: "number",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Start reading"),
                        params: {
                            sortPath: "start.reading",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "start.reading",
                                },
                            },
                            {
                                name: "number",
                            },
                        ],
                    },
                    {
                        field: "end.date",
                        type: "date",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "End date"),
                        params: {
                            sortPath: "end.date",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "end.date",
                                },
                            },
                        ],
                    },
                    {
                        field: "end.reading",
                        type: "number",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "End reading"),
                        params: {
                            sortPath: "end.reading",
                        },
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "end.reading",
                                },
                            },
                            {
                                name: "number",
                            },
                        ],
                    },
                    {
                        field: "total_consumption",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Total"),
                        type: "number",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                        },
                    },
                    {
                        field: "unit",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Unit"),
                    },
                    {
                        field: "billing_factor",
                        type: "number",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Billing multiplier"),
                    },
                    {
                        field: "billing_category",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Billing category"),
                    },
                    {
                        field: "non_billable",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Non-billable"),
                        formatter: "checkbox",
                    },
                    {
                        field: "tariff",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Tariff"),
                    },
                    {
                        field: "rental",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Rental"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "rental.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "consumer",
                        name: this.$fn.pgettext("MeterConsumptionBrowser", "Consumer"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.code }} | {{ $value.name }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "consumer.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("MeterConsumptionBrowser"),
                icon: this.$config.meterConsumption.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4450_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_4452_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_reloadSlickgrid_4456_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_2248226175642056_close_4455_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_2248226175642056_showModal_4454_getActionArgs($event) {
        return {
            name: "MeterConsumption",
            props: {
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_4453_getWhen($event) {
        return $event.data.column.id === 'total_consumption';
    }
    async act_2248226175642056_showModal_4458_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.invoice.id,
                modal: true,
            },
        };
    }
    async evh_2248226175642056_command_4457_getWhen($event) {
        return $event.data.column.id === 'invoice';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_4615685607825208_reloadSlickgrid_4460_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_4615685607825208_input(event, scope) {
        return await this.actions.evh_4615685607825208_input.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_4462_getActionArgs($event) {
        return {
            name: "UploadMeterReadings",
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    async act_6806515264385235_reloadSlickgrid_4466_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_6806515264385235_close_4465_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_6806515264385235_showModal_4464_getActionArgs($event) {
        return {
            name: "MeterConsumption",
        };
    }
    async evh_6806515264385235_click(event, scope) {
        return await this.actions.evh_6806515264385235_click.executeFromDOM(this, event, scope);
    }
    async act_8116269939469002_reloadSlickgrid_4470_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_8116269939469002_request_4468_getActionArgs($event) {
        return {
            operation: "bulk_delete_meter_consumption",
            data: {
                items: _.map(this.selectedItems, p => ({ id: p.id }))
            },
        };
    }
    async evh_8116269939469002_click(event, scope) {
        return await this.actions.evh_8116269939469002_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4450 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4450_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4449 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4450,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4449],
        });
        const act_2248226175642056_setData_4452 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_4452_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_4451 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_4452,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_4451],
        });
        const act_2248226175642056_reloadSlickgrid_4456 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_4456_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_close_4455 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_4456,
            event: "close",
            when: this.evh_2248226175642056_close_4455_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_showModal_4454 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_4454_getActionArgs,
            events: [evh_2248226175642056_close_4455],
        });
        const evh_2248226175642056_command_4453 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_4454,
            event: "command",
            when: this.evh_2248226175642056_command_4453_getWhen,
            displayName: "showModal",
        });
        const act_2248226175642056_showModal_4458 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_4458_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_4457 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_4458,
            event: "command",
            when: this.evh_2248226175642056_command_4457_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_4453, evh_2248226175642056_command_4457],
        });
        const act_4615685607825208_reloadSlickgrid_4460 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4615685607825208_reloadSlickgrid_4460_getActionArgs,
            events: [],
        });
        const evh_4615685607825208_input_4459 = new core_1.actions.EventHandlerImpl({
            action: act_4615685607825208_reloadSlickgrid_4460,
            event: "input",
            displayName: "reloadSlickgrid",
        });
        const evh_4615685607825208_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4615685607825208_input_4459],
        });
        const act_8320016629450276_showModal_4462 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_4462_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_click_4461 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_4462,
            event: "click",
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_4461],
        });
        const act_6806515264385235_reloadSlickgrid_4466 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6806515264385235_reloadSlickgrid_4466_getActionArgs,
            events: [],
        });
        const evh_6806515264385235_close_4465 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_reloadSlickgrid_4466,
            event: "close",
            when: this.evh_6806515264385235_close_4465_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_6806515264385235_showModal_4464 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6806515264385235_showModal_4464_getActionArgs,
            events: [evh_6806515264385235_close_4465],
        });
        const evh_6806515264385235_click_4463 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_showModal_4464,
            event: "click",
            displayName: "showModal",
        });
        const evh_6806515264385235_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6806515264385235_click_4463],
        });
        const act_8116269939469002_reloadSlickgrid_4470 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8116269939469002_reloadSlickgrid_4470_getActionArgs,
            events: [],
        });
        const evh_8116269939469002_success_4469 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_reloadSlickgrid_4470,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_8116269939469002_request_4468 = new core_1.actions.RequestAction({
            actionArgs: this.act_8116269939469002_request_4468_getActionArgs,
            displayName: "deleteItems",
            events: [evh_8116269939469002_success_4469],
        });
        const evh_8116269939469002_click_4467 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_request_4468,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_8116269939469002_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8116269939469002_click_4467],
        });
        return {
            act_7315092382398562_closeModal_4450,
            evh_7315092382398562_close_4449,
            evh_7315092382398562_close,
            act_2248226175642056_setData_4452,
            evh_2248226175642056_selectedRowsChanged_4451,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_reloadSlickgrid_4456,
            evh_2248226175642056_close_4455,
            act_2248226175642056_showModal_4454,
            evh_2248226175642056_command_4453,
            act_2248226175642056_showModal_4458,
            evh_2248226175642056_command_4457,
            evh_2248226175642056_command,
            act_4615685607825208_reloadSlickgrid_4460,
            evh_4615685607825208_input_4459,
            evh_4615685607825208_input,
            act_8320016629450276_showModal_4462,
            evh_8320016629450276_click_4461,
            evh_8320016629450276_click,
            act_6806515264385235_reloadSlickgrid_4466,
            evh_6806515264385235_close_4465,
            act_6806515264385235_showModal_4464,
            evh_6806515264385235_click_4463,
            evh_6806515264385235_click,
            act_8116269939469002_reloadSlickgrid_4470,
            evh_8116269939469002_success_4469,
            act_8116269939469002_request_4468,
            evh_8116269939469002_click_4467,
            evh_8116269939469002_click,
            deleteItems: act_8116269939469002_request_4468,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MeterConsumptionBrowser.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterConsumptionBrowser.prototype, "onSize", null);
MeterConsumptionBrowser = __decorate([
    (0, vue_property_decorator_1.Component)()
], MeterConsumptionBrowser);
exports.default = MeterConsumptionBrowser;
vue_property_decorator_1.Vue.component("MeterConsumptionBrowser", MeterConsumptionBrowser);
